import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ScanSearch, ListChecks, History, ArrowRight, Bike, Car, Gauge } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMHdvcmtzaG9wJTIwY2FyJTIwcmVwYWlyfGVufDB8fHx8MTc5MDA1Njg5OXww&ixlib=rb-4.1.0&q=85";

const FEATURES = [
  { icon: ListChecks, title: "Questionario Guidato", desc: "Seleziona i sintomi da liste dedicate ad auto e moto per una diagnosi mirata." },
  { icon: ScanSearch, title: "Diagnosi AI", desc: "Descrivi il rumore o il comportamento anomalo: l'AI individua cause e soluzioni." },
  { icon: Gauge, title: "Codici OBD-II", desc: "Cerca i codici errore (P0300, P0420...) con spiegazioni chiare in italiano." },
  { icon: History, title: "Storico Personale", desc: "Salva ogni diagnosi e segna i problemi risolti nel tuo garage digitale." },
];

export default function Landing() {
  const { user } = useAuth();
  const cta = user ? "/diagnosi" : "/accedi";

  return (
    <div className="pt-16">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B0F14]/70 via-[#0B0F14]/85 to-[#0B0F14]" />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 py-24 sm:py-32">
          <div className="max-w-2xl rise">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#F97316]/40 bg-[#F97316]/10 px-3 py-1 text-xs font-mono text-[#F97316] mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#F97316] animate-pulse" /> DIAGNOSTICA INTELLIGENTE
            </div>
            <h1 className="font-display font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              Il tuo meccanico
              <span className="block text-[#F97316]">sempre in tasca.</span>
            </h1>
            <p className="mt-6 text-lg text-zinc-300 max-w-lg">
              Diagnostica problemi di auto e moto in pochi secondi. Sintomi guidati, analisi AI e
              consigli passo-passo per risolvere davvero il guasto.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to={cta}
                data-testid="hero-cta-btn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#F97316] hover:bg-[#EA580C] text-black font-bold transition-all shadow-[0_0_28px_rgba(249,115,22,0.4)] hover:shadow-[0_0_40px_rgba(249,115,22,0.55)]"
              >
                Avvia una diagnosi <ArrowRight className="w-5 h-5" />
              </Link>
              <Link
                to="/codici-obd"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-white/15 hover:border-[#06B6D4]/60 hover:text-[#06B6D4] font-semibold transition-colors"
              >
                Cerca codici OBD-II
              </Link>
            </div>
            <div className="mt-10 flex gap-8">
              <div className="flex items-center gap-2 text-zinc-400">
                <Car className="w-5 h-5 text-[#06B6D4]" /> <span className="text-sm">Auto</span>
              </div>
              <div className="flex items-center gap-2 text-zinc-400">
                <Bike className="w-5 h-5 text-[#06B6D4]" /> <span className="text-sm">Moto</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="rounded-2xl bg-[#111823] border border-white/8 p-6 hover:border-[#F97316]/40 transition-colors group"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <span className="inline-flex w-11 h-11 rounded-xl bg-[#F97316]/10 items-center justify-center mb-4 group-hover:bg-[#F97316]/20 transition-colors">
                <f.icon className="w-5 h-5 text-[#F97316]" />
              </span>
              <h3 className="font-display font-bold text-lg mb-1.5">{f.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
